import { isNumber, isObject, isString } from 'lodash/lang'
import { isFloat } from 'utils/isFloat'

const hasSuffixVat = (x) => x.indexOf('with_vat') > -1

const parseValue = (v) => (isFloat(v) ? parseFloat(v.toFixed(2)) : v)

const prepareChartData = (items, summary) => {
  const idsIncludeVat = []

  const summaryMod = Object.entries(summary).reduce(
    (previousValue, currentValue) => {
      const [key, value] = currentValue

      if (isObject(value)) {
        const children = {}
        Object.entries(value).forEach(([k, v]) => {
          const isVat = hasSuffixVat(k)

          if (isString(v) || isNumber(v)) {
            children[k] = { value: parseValue(v) }

            if (isVat) {
              idsIncludeVat.push(k)
            }
          }
        })

        if (Object.keys(children).length) {
          previousValue = {
            ...previousValue,
            [key]: {
              children: children,
            },
          }
        }
      } else if (isString(value) || isNumber(value)) {
        const isVat = hasSuffixVat(key)

        previousValue[key] = { value: parseValue(value) }

        if (isVat) {
          idsIncludeVat.push(key)
        }
      }

      return previousValue
    },
    {}
  )

  const itemsMod = items.map((item) => {
    return Object.entries(item).reduce((previousValue, currentValue) => {
      const [key, value] = currentValue
      if (isObject(value)) {
        Object.entries(value).forEach(([k, v]) => {
          if (!previousValue[key]) {
            previousValue[key] = {}
          }
          if (isString(v) || isNumber(v)) {
            previousValue[key][k] = { value: parseValue(v) }
          }
        })
      } else if (key !== 'date') {
        if (isString(value) || isNumber(value)) {
          previousValue[key] = { value: parseValue(value) }
        }
      } else {
        previousValue[key] = value
      }
      return previousValue
    }, {})
  })

  idsIncludeVat.forEach((id) => {
    const idWithoutVat = id.replace('_with_vat', '')

    summaryMod[idWithoutVat].valueIncludeVat = summaryMod[id].value
    itemsMod.forEach((item) => {
      if (item[id]) {
        item[idWithoutVat].valueIncludeVat = item[id].value
        delete item[id]
      }
    })

    delete summaryMod[id]
  })

  return {
    items: itemsMod,
    summary: summaryMod,
  }
}

export default prepareChartData
